"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrailingSlot = exports.LeadingSlot = void 0;

var tslib_1 = require("tslib");

var ui_flex_1 = require("@hopin-team/ui-flex");

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

exports.LeadingSlot = (0, styled_components_1.default)(ui_flex_1.Flex).attrs({
  alignItems: 'center'
})(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  gap: 1rem;\n  margin: 0.75rem 1.5rem;\n\n  @media (max-width: 35rem) {\n    margin: 0.75rem;\n    gap: 0.5rem;\n  }\n"], ["\n  gap: 1rem;\n  margin: 0.75rem 1.5rem;\n\n  @media (max-width: 35rem) {\n    margin: 0.75rem;\n    gap: 0.5rem;\n  }\n"])));
exports.TrailingSlot = (0, styled_components_1.default)(ui_flex_1.Flex).attrs({
  alignItems: 'center',
  justifyContent: 'flex-end'
})(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  gap: 1rem;\n  margin: 0.75rem 1.5rem;\n\n  @media (max-width: 35rem) {\n    margin: 0.75rem;\n    gap: 0.5rem;\n  }\n"], ["\n  gap: 1rem;\n  margin: 0.75rem 1.5rem;\n\n  @media (max-width: 35rem) {\n    margin: 0.75rem;\n    gap: 0.5rem;\n  }\n"])));
var templateObject_1, templateObject_2;